// Push events to GTM dataLayer — GA4 reads from GTM
const dl = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const trackPageView = (path, title) => {
  dl().push({ event: 'page_view', page_path: path, page_title: title });
};

export const trackCTA = (name, location) => {
  dl().push({ event: 'cta_click', cta_name: name, cta_location: location });
};

export const trackFormSubmit = (formName, extra = {}) => {
  dl().push({ event: 'form_submit', form_name: formName, ...extra });
};

export const trackDemoView = vertical => {
  dl().push({ event: 'demo_view', vertical: vertical || 'general' });
};

export const trackWebVital = ({ name, value, rating }) => {
  dl().push({ event: 'web_vital', metric_name: name, metric_value: Math.round(value), metric_rating: rating });
};
